module.exports = __webpack_public_path__ + "img/connectaudio.23bf3543.svg";